import { render, staticRenderFns } from "./LeadsPage.vue?vue&type=template&id=1ba0e6d8&"
import script from "./LeadsPage.vue?vue&type=script&lang=js&"
export * from "./LeadsPage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsPage.vue?vue&type=style&index=0&id=1ba0e6d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports